import React, { useEffect, useContext, useState } from 'react';
import { NavContext, NavRoutes, UserContext, ToastContext } from '../../../contexts';
import { GlobalSettingsProvider, GlobalSettingsContext } from './GlobalSettingsContext';
import Switch from '@material-ui/core/Switch';
import CircularProgress from '@material-ui/core/CircularProgress';

import {
	Paper,
	Avatar,
	Table,
	TableHead,
	TableBody,
	TableRow,
	TableCell,
	Typography,
	Hidden,
	Button,
	LinearProgress
} from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
	newYearContainer: {
		display: 'flex'
	},
	newYearDescription: {
		alignSelf: 'center',
		marginRight: '20px',
		fontSize: '1rem'
	},
	newYearBody: {
		width: "60px",
		margin: "0px 40px 0px 0px"
	},
	newYearButton: {
		fontSize: '12px'
	},
	root: {
		width: '100%',
		overflow: 'hidden',
		marginTop: '50px'
	},
	author: {
		display: 'flex',
		alignItems: 'center'
	},
	avatar: {
		marginRight: theme.spacing(1)
	},
	budgetSessionContainer: {
		display: 'flex',
		justifyContent: 'center'
	},
	budgetSessionName: {
		alignSelf: 'center',
		marginLeft: '15px',
		marginRight: '15px',
	},
	buttonContainer: {
		display: 'flex',
		justifyContent: 'space-evenly'
	},
	table: {

	}
}));

const PageContent = (props) => {
	const { setBreadcrumbRoot, addBreadcrumbToken } = useContext(NavContext);
	const { showSuccessMessage, showErrorMessage } = useContext(ToastContext);
	const classes = useStyles();

	const {
		setGlobalSettingAsync
	} = useContext(GlobalSettingsContext);

	const {
    getGlobalSettingsAsync,
		isLoadingGlobalSettings,
		globalSettings
	} = useContext(UserContext);

	const [isSettingGlobalSetting, setIsSettingGlobalSetting] = useState(false);

	useEffect(() => {
		addBreadcrumbToken("Global settings");
		getGlobalSettingsAsync();
	}, [])

	return (
		<div>
			{isLoadingGlobalSettings ?
				<LinearProgress color="primary" /> :
				<>
					<Paper className={classes.root}>
						<Table className={classes.table} arial-label="role table">
							<TableHead>
								<TableRow>
									<TableCell align="left">Setting</TableCell>
									<TableCell align="left">Active</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{globalSettings &&
									globalSettings.length > 0 &&
									globalSettings.map((setting, index) =>
										<TableRow hover key={index}>
											<TableCell component="th" scope="row">
												<div className={classes.author}>
													<Typography>
														{
															setting.title
														}
													</Typography>
												</div>
											</TableCell>
											<TableCell align="left">
												{
													isSettingGlobalSetting ?
													<CircularProgress color="primary" /> :
													<Switch
														color="primary"
														checked={setting.value}
														onChange={() => {
															sendDataAsync();

															async function sendDataAsync() {
																setIsSettingGlobalSetting(true);
																await setGlobalSettingAsync({ globalSettingId : setting.globalSettingId, value: !setting.value });
																getGlobalSettingsAsync();
																setIsSettingGlobalSetting(false);
															}
														}}
													/>
												}
											</TableCell>
										</TableRow>
									)}
							</TableBody>
						</Table>
					</Paper>
				</>
			}
		</div>
	);
}

export const GlobalSettingsPage = () => {
	return (
		<GlobalSettingsProvider>
			<PageContent />
		</GlobalSettingsProvider>
	);
}